import useRequest from '@/websdk/utils/request';
export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_FIRST_INSPECTION_SAMPLE',
    url: `/api/inspection/first/samples/`,
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
